// PPF section catalogue — DigiCut-style names, same order as backend/ppf.py
export const PPF_TYPES = [
  ["ppf_hood", "Hood"], ["ppf_fenders", "Fender"], ["ppf_bumper", "Bumper"], ["ppf_doors", "Door"], ["ppf_quarter_panels", "Quarter Panel"],
  ["ppf_rockers", "Rocker"], ["ppf_mirrors", "Mirror"], ["ppf_headlights", "Headlamp"], ["ppf_hatch", "Hatch"], ["ppf_roof", "Roof"],
  ["ppf_wheel_splash", "Wheel Splash"], ["ppf_a_pillars", "A-Pillar"], ["ppf_door_cups", "Door Cup"], ["ppf_door_edges", "Door Edge"],
  ["ppf_trunk_ledge", "Trunk Ledge"], ["ppf_full_body", "Full Body"], ["ppf_other", "Other Panel"],
];
export const PPF_TYPE_KEYS = PPF_TYPES.map(([k]) => k);
export const PPF_LABEL = Object.fromEntries(PPF_TYPES);
